var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"aui-card--fill",attrs:{"shadow":"never"}},[(_vm.isAddByAgent == 1)?_c('editQyyhUser',{attrs:{"userId":_vm.userId}}):_c('qyyhUserOld',{ref:"qyyhUserOld"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }